import { useFeatureFlagEnabled } from 'posthog-js/react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { ScrollArea } from '@/components/ui/scroll-area';

import { useChangelogStatus } from '../../application/use-changelog-status';
import { FeatureFlag } from '../../types';
import { ChangelogList } from './ChangelogList';

export const NotificationDialog = ({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) => {
  const { markChangelogsAsRead } = useChangelogStatus();
  const { t } = useTranslation();
  const isChangelogsEnabled = useFeatureFlagEnabled(FeatureFlag.CHANGELOGS);

  useEffect(() => {
    if (open) {
      markChangelogsAsRead();
    }
  }, [open, markChangelogsAsRead]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[90vh] p-0">
        <DialogHeader className="mx-6 mt-6">
          <DialogTitle className="text-2xl font-bold">
            {isChangelogsEnabled
              ? t('modules.mavue2.notificationDialog.title.whatsNew')
              : t('modules.mavue2.notificationDialog.title.welcome')}
          </DialogTitle>
        </DialogHeader>
        <ScrollArea className="max-h-[75vh] px-6 pb-6">
          <ChangelogList />
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};
